module.exports = __webpack_public_path__ + "img/ex-best.94ad625d.jpg";